import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const donutChartTool: Tool = {
  id: "donut-chart",
  name: () => m.donut_tool_name(),
  description: () => m.donut_tool_description(),
  icon: "🍩",
  basePath: "/donut-chart",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "donut-chart", "science"],
};
